var spoiler_default = {
  "fontElementMap": "JYcJX",
  "hideText": "bg17E",
  "onHoverText": "_8k9Qn",
  "hideBlock": "rUHPK",
  "smallBlur": "KJOja",
  "mediumBlur": "_8s0iu",
  "largeBlur": "ZPPW0",
  "hideBlock_gallery": "BwjNf",
  "overlay": "aixbe",
  "overlay_gallery": "Apl-d",
  "revealSpoilerBtn": "_9olgZ",
  "isMobile": "f3pV8",
  "onHoverBtn": "cUlY4",
  "spoilerWrapper": "afS4f",
  "spoilerDescription": "RUIvm",
  "spoilerContainer": "gOWQ0",
  "spoilerContainer_Gallery": "hdonm"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
